import React, { FC } from 'react';

import { Container, Column, Row } from '../../../../grid/Grid';
import { MaterialIcon } from '../../../../material-icon/MaterialIcon';
import { SearchFiltersBar } from '../../../../../search/components/search-filters-bar/SearchFiltersBar';

import styles from './modal_search_full_screen_header.module.scss';

type Props = {
  title: string;
  onClose: () => void;
  searchBarComponent: React.ReactNode;
};

export const ModalSearchFullScreenHeader: FC<Props> = ({
  title,
  onClose,
  searchBarComponent,
}) => {
  return (
    <div className={styles.container}>
      <Container className={styles.content}>
        <Row className={styles.row}>
          <Column medium={2} className={styles.titleContainer}>
            <div
              onClick={onClose}
              className={styles.link}
              data-test-id="search-modal-close"
            >
              <span className={styles.icon}>
                <MaterialIcon name="arrow_back" />
              </span>
              <p className={styles.title}>{title}</p>
            </div>
          </Column>
          <Column medium={10}>{searchBarComponent}</Column>
        </Row>
        <Row>
          <Column medium={12}>
            <SearchFiltersBar />
          </Column>
        </Row>
      </Container>
    </div>
  );
};
